import { request } from '@/api/apiUtils';
import { createEntityQuery } from '@/data/createEntityQuery';
import type { EntityDefinition, FetcherEntry } from '@/data/types';
import type { INotification, ResponseType } from '@/types';

/** Root: query-key prefix for this entity's slice of the cache (ADR 0010) */
export const NOTIFICATIONS_ROOT = ['notifications'] as const;

type NotificationsListParams = Record<string, never>;

const fetchers = {
    list: {
        key: () => [...NOTIFICATIONS_ROOT] as const,
        fetch: async (_args: NotificationsListParams = {} as NotificationsListParams): Promise<INotification[]> => {
            const response: ResponseType<INotification[]> = await request('user/notifications?filter=all&per_page=30');
            return response.data;
        },
    },
    // biome-ignore lint/suspicious/noExplicitAny: required for generic type inference
} satisfies Record<string, FetcherEntry<any, any>>;

export const notificationsEntity: EntityDefinition<typeof fetchers> = {
    name: 'notifications',
    roots: [NOTIFICATIONS_ROOT],
    fetchers,
};

export const useNotificationsList = createEntityQuery(notificationsEntity, 'list');

export type { NotificationsListParams };
